import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  AccountPayableVoidInput,
  AccountPayableMutationInput,
  AccountPayableUpdateInput,
  AccountPayableModel,
} from './model';

export function useCreateAccountPayable(
  options?: UseMutationOptions<
    ApiResult<AccountPayableModel>,
    ApiError,
    AccountPayableMutationInput
  >,
): UseMutationResult<
  ApiResult<AccountPayableModel>,
  ApiError,
  AccountPayableMutationInput
> {
  return useMutation<
    ApiResult<AccountPayableModel>,
    ApiError,
    AccountPayableMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'account-payables',
      method: 'POST',
      body,
      classType: AccountPayableModel,
    });
  }, options);
}

export function useUpdateAccountPayable(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    AccountPayableUpdateInput
  >,
): UseMutationResult<ApiResult<any>, ApiError, AccountPayableUpdateInput> {
  return useMutation<ApiResult<any>, ApiError, AccountPayableUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `account-payables/${body.id}`,
        method: 'PUT',
        body: body.body,
      });
    },
    options,
  );
}

export function useVoidAccountPayable(
  options?: UseMutationOptions<
    ApiResult<{ message: string }>,
    ApiError,
    AccountPayableVoidInput
  >,
): UseMutationResult<
  ApiResult<{ message: string }>,
  ApiError,
  AccountPayableVoidInput
> {
  return useMutation<
    ApiResult<{ message: string }>,
    ApiError,
    AccountPayableVoidInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `account-payables/${body.id}/void`,
      method: 'PATCH',
    });
  }, options);
}
